export default __webpack_public_path__ + "static/Foxy-9b26fe00b153a083b0a42a6230b30f56.png";